import { FC, useState } from "react";

import { TaskDriverStatusEnum } from "@/domain/models/common";

import {
  CameraPhotoWithCommentType,
  DriverCamera,
  DriverFlowBottomButton,
} from "../blocks";
import { DsTranslator } from "../components/ui";
import { useUpdateServiceMutation } from "../data/mutations/serviceMutations";
import { useUploadServicePhotoMutation } from "../data/mutations/storageMutations";
import { useUpdateTaskMutation } from "../data/mutations/taskMutations";
import { JobServiceTaskBaseType } from "../domain/task";
import { generateFirebaseTimestamp } from "../utils/date";
import { DriverTopActionButton } from "./DriverTopActionButton";

const DriverAddPhotoBeforeCleanupStep: FC<JobServiceTaskBaseType> = ({
  jobId,
  serviceId,
  taskId,
}) => {
  const { mutate: uploadServicePhoto, isPending: isUploadingServicePhoto } =
    useUploadServicePhotoMutation();

  const { mutate: updateService } = useUpdateServiceMutation();
  const { mutate: updateTask } = useUpdateTaskMutation();

  const [isCameraOpen, setIsCameraOpen] = useState(false);

  const openCamera = () => setIsCameraOpen(true);

  const closeCamera = () => setIsCameraOpen(false);

  const uploadPhoto = ({
    base64PhotoString,
    comment,
  }: CameraPhotoWithCommentType) => {
    uploadServicePhoto(
      {
        jobId,
        serviceId,
        base64PhotoString,
        baseName: "prejunkremoval",
      },
      {
        onSuccess: path => {
          const cleaningStartedAt = generateFirebaseTimestamp();

          updateService({
            jobId,
            serviceId,
            preJunkRemovalPhoto: {
              photoUrl: path,
              comment,
            },
            driverFlowStatus: TaskDriverStatusEnum.CLEANING_AREA,
            cleaningStartedAt,
          });

          updateTask({
            jobId,
            serviceId,
            taskId,
            driverFlowStatus: TaskDriverStatusEnum.CLEANING_AREA,
            cleaningStartedAt,
          });
        },
      },
    );
  };

  return (
    <div className="flex flex-col h-full w-full">
      {isCameraOpen ? (
        <DriverCamera
          mode="single-photo"
          onChoosePhoto={photo => {
            setIsCameraOpen(false);
            void uploadPhoto(photo);
          }}
          onCancelClick={closeCamera}
        />
      ) : (
        <>
          <DriverTopActionButton
            jobId={jobId}
            serviceId={serviceId}
            taskId={taskId}
          />
          <div className="flex flex-grow w-full flex-col justify-center">
            <DsTranslator
              variant="pageTitle"
              i18nProps={{
                i18nKey: "driver_photo_before_cleanup.step_2_title",
              }}
            />
          </div>
          <DriverFlowBottomButton
            onNextButtonClick={openCamera}
            isNextButtonLoading={isUploadingServicePhoto}
            nextButtonTitle="take_photo"
          />
        </>
      )}
    </div>
  );
};

export { DriverAddPhotoBeforeCleanupStep };
